export const FEATURE = {
  LINE_GROUP: 'line-group',
  LINE_OFFICIAL_NOTIFICATION: 'line-official-notification',
  GPT: 'gpt',
  REF_LINK: 'ref-link',
  LINE_RICH_MENU: 'line-rich-menu',
  ALL_IN_ONE_CHAT_NEW: 'all-in-one-chat-new',
  DRIVE_UPLOAD_IFRAME: 'drive-upload-iframe',
  FACEBOOK_SHOP: 'facebook-shop',
  EVENT_TRACKING: 'event-tracking',
  CUSTOMER_SUPPORT_SERVICE: 'customer-support-service'
}



// WEBPACK FOOTER //
// ./src/constants/feature.js